module.exports = __webpack_public_path__ + "3b12960f2135a5f1bf422debf405f70d.MP3";